<template>
  <div class="form-box">
    <h2 class="form-box-title">登录</h2>

    <div class="form-content">
      <!-- TODO v-if 微信登录和验证码登录 -->
      <el-form
        v-if="loginType === 'code'"
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-width="auto"
        class="demo-loginForm"
      >
        <el-form-item label="手机号" prop="mobile" style="margin-bottom: 5px">
          <el-input
            v-model="loginForm.mobile"
            placeholder="请输入手机号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="loginForm.code"
            class="code-input"
            placeholder="请输入验证码"
            autocomplete="off"
          >
          </el-input>
          <div class="input-code" @click="handleVerify">
            <span
              :style="{
                color: sending
                  ? 'rgba(153, 153, 153, 1)'
                  : 'rgba(51, 127, 255, 1)',
              }"
              >{{ sending ? `${count}S后重新获取` : '获取验证码' }}</span
            >
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="login-btn" type="primary" @click="submitForm()"
            >登录</el-button
          >
        </el-form-item>
      </el-form>

      <div v-else class="wechat-box"></div>
    </div>

    <p class="bottom-link">
      登录即同意
      <a
        href="https://wap3.wxls.pro/pages/user/userDescription/creditCommitment"
        >《网络信息服务信用承诺书"》</a
      >
      和
      <a href="https://wap3.wxls.pro/pages/user/userDescription/userAgreement"
        >《"用户协议及隐私政策"》</a
      >
    </p>

    <!-- <div class="social-links">
      <div class="item">微信登录</div>
    </div> -->

    <div v-show="showVerification" class="dialog-container">
      <div class="overlay"></div>
      <div class="dialog">
        <div class="header">滑动验证</div>
        <div id="content"></div>
        <div class="foot" id="close">
          <span style="cursor: pointer">关闭</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as Api from '@/api';
  import _ from 'lodash';
  export default {
    name: 'LoginContent',
    data() {
      return {
        loginForm: {
          mobile: '',
          code: '',
        },
        rules: {
          mobile: [
            {
              pattern: /^[1][3-9][0-9]{9}$/,
              trigger: ['blur'],
              message: '请输入正确手机号',
            },
          ],
          code: [
            {
              pattern: /^[A-Za-z0-9]+$/,
              trigger: ['blur'],
              message: '请输入正确验证码',
            },
          ],
        },
        sending: false, // 发送验证码状态
        count: 60, // 验证码倒计时
        isLoginFlag: false,
        loginType: 'code', // code 验证码登录，wechat微信登录
        showVerification: false, // 滑动验证sho
      };
    },

    mounted() {
      this.init_load();
      this.verification();
    },

    methods: {
      init_load() {
        this.sending = false;
        this.count = 60;
      },
      // 获取验证码
      handleVerify() {
        if (this.sending) return;
        if (!this.loginForm.mobile) {
          this.$message('请先输入手机号');
          return;
        }
        this.$refs.loginForm.validate((valid) => {
          valid && (this.showVerification = true);
        });
      },
      /**
       * 获取验证码接口请求
       * @param {Object} data 阿里云滑动验证的回调数据（接口传参用）
       */
      async getVerify(data) {
        this.count = 60;
        this.sending = true;
        try {
          const param = {
            phoneNumber: this.loginForm.mobile,
            codeType: 0,
            ...data,
          };
          await Api.user.getCode(param);
          this.countDown();
        } catch (error) {
          this.sending = false;
        }
      },
      /**
       * 阿里云滑动验证
       */
      verification() {
        const that = this;
        let count = 0;
        let nvc;
        // 阿里云滑动验证
        window.AWSC.use('nc', function (state, module) {
          nvc = module.init({
            appkey: 'FFFF0N0000000000B4A6',
            scene: 'nc_login_h5',
            renderTo: 'content',
            width: 300,
            success: function (data) {
              // h5uni.postMessage({
              // 	data
              // })
              // wv.hide()
              that.showVerification = false;
              that.getVerify(data);
              nvc.reset();
            },
            // test: module.TEST_PASS,
            // 滑动验证失败时触发该回调参数。
            fail: function (failCode) {
              window.console && console.log(failCode, 'failCode');
            },
            error: function (e) {
              console.log(e);
            },
          });
        });

        document.getElementById('close').addEventListener('click', () => {
          that.showVerification = false;
          nvc.reset();
          // wv.hide();
        });
      },
      countDown() {
        if (this.count > 0) {
          this.count--;
          const timer = setTimeout(() => {
            clearTimeout(timer);
            this.countDown();
          }, 1000);
        } else {
          this.sending = false;
          this.count = 60;
        }
      },
      // 登录
      submitForm: _.throttle(
        function () {
          this.$refs.loginForm.validate((valid) => {
            if (!this.loginForm.mobile) {
              this.$message('请输入手机号');
              return;
            }
            if (!this.loginForm.code) {
              this.$message('请输入验证码');
              return;
            }
            valid && this.tel_login();
          });
        },
        2000,
        { trailing: false },
      ),
      async tel_login() {
        const data = {
          phoneNumber: this.loginForm.mobile,
          phoneCode: this.loginForm.code,
        };
        this.isLoginFlag = false;
        try {
          this.$store.dispatch('user/login', data);
        } catch (error) {
        } finally {
          this.isLoginFlag = true;
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .form-box-title {
    font-size: 24px;
    text-align: center;
    color: #000;
    margin-top: -10px;
  }
  .form-content {
    width: 100%;
    height: 310px;
  }
  .demo-loginForm {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    // padding-top: 40px;
  }

  .login-btn {
    width: 100%;
    height: 54px;
    font-size: 14px;
    border-radius: @borderRadius;
  }

  .bottom-link {
    text-align: center;
    a {
      color: #337fff;
      &:active {
        color: #337fff;
      }
    }
  }

  .social-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 30px;
    .item {
      cursor: pointer;
    }
  }

  .input-code {
    position: absolute;
    right: 18px;
    bottom: 0;
    height: 54px;
    line-height: 54px;
    text-align: right;
    cursor: pointer;
    span {
      color: #337fff;
      &:active {
        color: #615dfa;
      }
    }
  }

  .code-input /deep/.el-input__inner {
    padding-right: 150px;
  }

  /deep/ .el-input__inner {
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    border-radius: @borderRadius;
  }

  /deep/ .el-form-item__label {
    font-size: 16px;
    font-weight: 600;
    height: 54px;
    line-height: 54px;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  // 阿里云滑动验证样式
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .dialog {
    position: fixed;
    top: 45%;
    left: 50%;
    width: 35vw;
    min-height: 20vw;
    overflow: hidden;
    font-size: 2.2vw;
    background-color: #fff;
    border-radius: 4.2vw;
    transform: translate3d(-50%, -50%, 0);
    backface-visibility: hidden;
    transition: 0.3s;
    transition-property: transform, opacity;
    z-index: 999;
  }

  .dialog .header {
    padding-top: 1.93vw;
    font-weight: 500;
    line-height: 2.4vw;
    text-align: center;
  }

  .dialog #content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 10vw;
    margin-bottom: 3vw;
    border-bottom: 1px solid #eee;
  }

  .nc_1_nocaptcha {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .foot {
    margin-top: 11vw;
    text-align: center;
    color: red;
    margin-bottom: 1vw;
    font-size: 2.2vw;
  }
</style>
